import { render, staticRenderFns } from "./AssetsAndLiabilitiesSection.vue?vue&type=template&id=78279154"
import script from "./AssetsAndLiabilitiesSection.vue?vue&type=script&lang=js"
export * from "./AssetsAndLiabilitiesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports